const userDataKey = "userData";
const userHostDataKey = "userHostData";
const portalDataKey = "portalData";
const permissionsDataKey = "permissionsData";
const permittedActions = "permittedActions";
const setUserDataLS = (user, isHost) => {
  localStorage.setItem(
    userDataKey,
    JSON.stringify({
      user,
      isHost
    })
  );
};
const checkIsUserDataLS = () => {
  return localStorage.getItem(userDataKey) !== null;
};
const getUserDataLS = () => {
  return JSON.parse(localStorage.getItem(userDataKey));
};
const removeUserDataLS = () => {
  localStorage.removeItem(userDataKey);
};

const setPortalDataDataLS = portalData => {
  console.log("portalData", portalData)
  localStorage.setItem(
    portalDataKey,
    JSON.stringify({
      portalTitle: portalData.company_name,
      portalId: portalData.portal_id
    })
  );
  // console.log("localStorage", localStorage)
};
const checkIsPortalDataLS = () => {
  return localStorage.getItem(portalDataKey) !== null;
};
const getPortalDataLS = () => {
  return JSON.parse(localStorage.getItem(portalDataKey));
};
const removePortalDataLS = () => {
  localStorage.removeItem(portalDataKey);
};

const setPermissionsDataDataLS = permissionsData => {
  localStorage.setItem(permissionsDataKey, JSON.stringify(permissionsData));
};
const setPermittedActions = permittedActions => {
  localStorage.setItem(permittedActions, JSON.stringify(permittedActions));
};
const checkIsPermissionsDataLS = () => {
  return localStorage.getItem(permissionsDataKey) !== null;
};
const getPermissionsDataLS = () => {
  return JSON.parse(localStorage.getItem(permissionsDataKey));
};
const removePermissionsDataLS = () => {
  localStorage.removeItem(permissionsDataKey);
};

export {
  setUserDataLS,
  checkIsUserDataLS,
  getUserDataLS,
  removeUserDataLS,
  setPortalDataDataLS,
  getPortalDataLS,
  checkIsPortalDataLS,
  removePortalDataLS,
  getPermissionsDataLS,
  checkIsPermissionsDataLS,
  setPermissionsDataDataLS,
  removePermissionsDataLS,
  setPermittedActions
};
